import { render, staticRenderFns } from "./ChoiceEditRow.vue?vue&type=template&id=efa775f8&scoped=true&"
import script from "./ChoiceEditRow.vue?vue&type=script&lang=ts&"
export * from "./ChoiceEditRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa775f8",
  null
  
)

export default component.exports